import { get, post, put, patch, del } from '../../apiClient';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Industry Master APIs
export const industryService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/industries${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },
    // ... (repeating for other services)


    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/industries`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/industries/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/industries/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/industries/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/industries/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Decision Maker Master APIs
export const decisionMakerService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/decision-makers${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/decision-makers`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/decision-makers/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/decision-makers/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/decision-makers/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/decision-makers/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Course Type Master APIs
export const courseTypeService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('activeOnly', options.isActive ? 'true' : 'false');
            } else if (options.activeOnly !== undefined) {
                params.append('activeOnly', options.activeOnly ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/course-types${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/course-types`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/course-types/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/course-types/${id}/toggle`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/course-types/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/course-types/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Content Type Master APIs
export const contentTypeService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('activeOnly', options.isActive ? 'true' : 'false');
            } else if (options.activeOnly !== undefined) {
                params.append('activeOnly', options.activeOnly ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/content-types${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/content-types`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/content-types/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/content-types/${id}/toggle`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/content-types/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/content-types/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Document Type Master APIs
export const documentTypeService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            // Note: The previous getAll implementations for industry had a bug where params were defined but not used in URL construction. 
            // I'm fixing it here for documentTypeService, ensuring query string is attached.
            const url = `${API_BASE_URL}/config/document-types${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getDropdown: async () => {
        try {
            const url = `${API_BASE_URL}/config/document-types/dropdown`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/document-types`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/document-types/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/document-types/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/document-types/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/document-types/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Regularization Reason Master APIs
export const regularizationReasonService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/regularization-reasons${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getDropdown: async () => {
        try {
            const url = `${API_BASE_URL}/config/regularization-reasons/dropdown`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/regularization-reasons`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/regularization-reasons/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/regularization-reasons/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/regularization-reasons/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/regularization-reasons/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Leave Type Master APIs
export const leaveTypeService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/leave-types${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getDropdown: async () => {
        try {
            const url = `${API_BASE_URL}/config/leave-types/dropdown`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/leave-types`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/leave-types/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/leave-types/${id}/toggle-status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/leave-types/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/leave-types/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Holiday Type Master APIs
export const holidayTypeService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/holiday-types${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getDropdown: async () => {
        try {
            const url = `${API_BASE_URL}/config/holiday-types/dropdown`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/holiday-types`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/holiday-types/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/holiday-types/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/holiday-types/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/holiday-types/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Policy Category Master APIs
export const policyCategoryService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/policy-categories${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getDropdown: async () => {
        try {
            const url = `${API_BASE_URL}/config/policy-categories/dropdown`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/policy-categories`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/policy-categories/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/policy-categories/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/policy-categories/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/policy-categories/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Source Master APIs
export const sourceService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/sources${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/sources`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/sources/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/sources/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/sources/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/sources/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Lead Source Master APIs
export const leadSourceService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/lead-sources${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/lead-sources`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/lead-sources/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/lead-sources/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/lead-sources/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/lead-sources/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Lead Document Type Master APIs
export const leadDocumentTypeService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/lead-document-types${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getDropdown: async () => {
        try {
            const url = `${API_BASE_URL}/config/lead-document-types/dropdown`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/lead-document-types`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/lead-document-types/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/lead-document-types/${id}/toggle-status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/lead-document-types/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/lead-document-types/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Lead Category Master APIs
export const leadCategoryService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/lead-categories${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getDropdown: async () => {
        try {
            const url = `${API_BASE_URL}/config/lead-categories/dropdown`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/lead-categories`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/lead-categories/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/lead-categories/${id}/toggle-status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/lead-categories/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/lead-categories/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Experience Level Master APIs
export const experienceService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/experience-levels${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/experience-levels`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/experience-levels/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/experience-levels/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/experience-levels/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/experience-levels/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Skill Master APIs
export const skillService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/skills${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },
    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/skills`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },
    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/skills/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },
    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/skills/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },
    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/skills/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },
    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/skills/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Job Requirement Master APIs
export const requirementService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/job-requirements${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },
    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/job-requirements`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },
    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/job-requirements/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },
    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/job-requirements/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },
    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/job-requirements/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },
    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/job-requirements/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Salary Component Master APIs
export const salaryComponentService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            if (options.type) {
                params.append('type', options.type);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/salary-components${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/salary-components`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/salary-components/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/salary-components/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/salary-components/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/salary-components/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Employment Type Master APIs
export const employmentTypeService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/employment-types${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/employment-types`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/employment-types/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/employment-types/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/employment-types/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/employment-types/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Employee Team Master APIs
export const employeeTeamService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/employee-teams${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/employee-teams`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/employee-teams/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/employee-teams/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/employee-teams/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/employee-teams/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};




// Interview Round Master APIs
export const interviewRoundService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/interview-rounds${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/interview-rounds`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/interview-rounds/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/interview-rounds/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/interview-rounds/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/interview-rounds/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Lead Status Master APIs
export const leadStatusService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/lead-statuses${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/lead-statuses`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/lead-statuses/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/lead-statuses/${id}/toggle-status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/lead-statuses/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/lead-statuses/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

export default {
    industryService,
    decisionMakerService,
    courseTypeService,
    documentTypeService,
    regularizationReasonService,
    leaveTypeService,
    holidayTypeService,
    policyCategoryService,
    sourceService,
    leadSourceService,
    leadDocumentTypeService,
    leadCategoryService,
    experienceService,
    salaryComponentService,
    employmentTypeService,
    employeeTeamService,
    skillService,
    requirementService,
    interviewRoundService,
    leadStatusService
};

// Revenue Type Master APIs
export const revenueTypeService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/revenue-types${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/revenue-types`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/revenue-types/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/revenue-types/${id}/toggle-status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/revenue-types/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/revenue-types/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Lead Bucket Master APIs
export const leadBucketService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/lead-buckets${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/lead-buckets`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/lead-buckets/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/lead-buckets/${id}/toggle-status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/lead-buckets/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/lead-buckets/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Business Unit Master APIs
export const businessUnitService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/business-units${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/business-units`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/business-units/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/business-units/${id}/toggle-status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/business-units/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/business-units/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Last Active Channel Master APIs
export const lastActiveChannelService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/last-active-channels${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/last-active-channels`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/last-active-channels/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/last-active-channels/${id}/toggle-status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/last-active-channels/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/last-active-channels/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

export const companySizeService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/company-sizes${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/company-sizes`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/company-sizes/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/company-sizes/${id}/toggle-status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/company-sizes/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/company-sizes/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

export const wfhReasonCategoryService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/wfh-reason-categories${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/wfh-reason-categories`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/wfh-reason-categories/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/wfh-reason-categories/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/wfh-reason-categories/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/wfh-reason-categories/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

// Website Source Master APIs
export const websiteSourceService = {
    getAll: async (options = {}) => {
        try {
            const params = new URLSearchParams();
            if (options.isActive !== undefined) {
                params.append('active', options.isActive ? 'true' : 'false');
            }
            if (options.search && options.search.trim()) {
                params.append('search', options.search.trim());
            }
            if (options.startDate) {
                params.append('startDate', options.startDate);
            }
            if (options.endDate) {
                params.append('endDate', options.endDate);
            }
            // Populate createdBy and updatedBy with user details
            params.append('populate', 'createdBy,updatedBy');
            const queryString = params.toString();
            const url = `${API_BASE_URL}/config/website-sources${queryString ? `?${queryString}` : ''}`;
            const response = await get(url);
            return response;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await post(`${API_BASE_URL}/config/website-sources`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await put(`${API_BASE_URL}/config/website-sources/${id}`, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await patch(`${API_BASE_URL}/config/website-sources/${id}/status`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await del(`${API_BASE_URL}/config/website-sources/${id}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    bulkDelete: async (ids) => {
        try {
            const response = await post(`${API_BASE_URL}/config/website-sources/bulk-delete`, { ids });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

